import get from 'lodash/get';
import last from 'lodash/last';
import isEmpty from 'lodash/isEmpty';
import { getUserId, getPartnerUserId, getPartnerFirstName } from '../user/userSelectors';

const DEFAULT_OBJECT = {};

export const getChecklist = state => get(state, 'checklist', DEFAULT_OBJECT);

export const getChecklistUIState = state => get(state, 'checklist.checklist', DEFAULT_OBJECT);

export const getChecklistLoading = (state) => {
  const checklist = getChecklistUIState(state);
  return checklist.busy;
};

export const getChecklistTaskGroups = (state) => {
  const checklist = getChecklist(state);
  return get(checklist, 'tasks.groups');
};

export const getFilteredChecklistTaskGroups = (state) => {
  const checklist = getChecklist(state);
  return get(checklist, 'tasks.filteredTasksGroups');
};

export const getChecklistTasks = state => get(state, 'checklist.tasks.byId', {});

export const getChecklistTaskById = (state, taskId) => {
  const tasks = getChecklistTasks(state);

  return tasks[taskId] || DEFAULT_OBJECT;
};

export const getSoonestChecklistTask = (state) => {
  const groups = getChecklistTaskGroups(state);
  const tasks = getChecklistTasks(state);
  const firstId = get(groups, '[0].taskIds[0]');

  return tasks[firstId];
};

export const getActiveTaskId = state => get(state, 'checklist.tasks.selectedId');

export const getActiveOrInvitedPartner = (state) => {
  const partnerArray = get(state, 'user.partnerContext');
  return partnerArray.filter(p => p.status !== 'REVOKED_INVITE' && p.status !== 'REMOVED_USER')[0] || {};
};

export const getTaskFilters = (state) => {
  const checklist = getChecklistUIState(state);
  return checklist.filters;
};

export const getTaskFilteredIds = (state) => {
  const checklist = getChecklist(state);
  return checklist.tasks.filteredIds;
};

export const getFirstFilterResult = (state) => {
  const filterIds = getTaskFilteredIds(state);

  return filterIds[0];
};

export const getNoFilterResults = (state) => {
  const checklist = getChecklistUIState(state);

  return checklist.noFilterResults;
};

export const getIsLastTask = (state, taskId) => {
  const taskGroups = getChecklistTaskGroups(state);
  const lastGroup = last(taskGroups);
  const lastTaskIdInGroup = last(lastGroup.taskIds);

  // not sure why taskId is a string...
  return parseInt(taskId, 10) === lastTaskIdInGroup;
};

export const getIsCustomTask = (state, taskId) => {
  const task = getChecklistTaskById(state, taskId);

  return !isEmpty(task) && !task.checklist_template_task_id;
};

export const getIsTaskAssignedToPartner = (state, taskId) => {
  const task = getChecklistTaskById(state, taskId);
  const partnerId = getPartnerUserId(state);

  return task.assigned_user_object_id === partnerId;
};

export const getIsTaskAssignedToUser = (state, taskId) => {
  const task = getChecklistTaskById(state, taskId);
  const userId = getUserId(state);

  return task.assigned_user_object_id === userId;
};

export const getPartnerDropdownState = (state) => {
  const checklist = getChecklistUIState(state);

  return checklist.invitePartnerViewActive;
};

export const getChecklistTaskCompletedAtByTaskId = (state, taskId) => {
  const task = getChecklistTaskById(state, taskId);

  return task.completed_at;
};

export const getTaskAddedByCopy = (state, taskId, userId) => {
  if (!userId) return null;

  const ownerId = getUserId(state);
  const partnerId = getPartnerUserId(state);
  const isPartner = userId === partnerId;
  const isUser = ownerId === userId;

  if (isPartner) {
    return getPartnerFirstName(state);
  }
  if (isUser) {
    return 'You';
  }

  return null;
};



// WEBPACK FOOTER //
// ./src/selectors/checklist/checklistSelectors.js